import React from 'react'

const PartnerAdd = (props) => {
  let link = `Fitbanx://mobile/MyPartner/add/${props.match.params.id}`;
  return (
    <h1>
      <a href={link} >
        Click here to add Partner
      </a>
    </h1>
  )
}

export default PartnerAdd



// WEBPACK FOOTER //
// ./src/components/PartnerAdd.js